import { render, staticRenderFns } from "./AsideLayout.vue?vue&type=template&id=55bf4f44&"
import script from "./AsideLayout.vue?vue&type=script&lang=js&"
export * from "./AsideLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports